import { render, staticRenderFns } from "./CustomFieldDuration.vue?vue&type=template&id=4e6e724c&lang=pug&"
import script from "./CustomFieldDuration.vue?vue&type=script&lang=js&"
export * from "./CustomFieldDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports